import { createApp } from "vue";
import "reflect-metadata";
import "core-js/stable";
import "regenerator-runtime/runtime";
import I18n from "./i18n";

//Vue.config.devtools = true;
import mainstore, { key } from "./store";

import quasar from "./quasar";
import Axios from "axios";
import App from "./App.vue";
import router from "./router";
import Sentry from "./sentry";

import mitt from "mitt"; // Import mitt
const emitter = mitt(); // Initialize mitt

import titleMixin from "./mixins/titleMixin";
//import MockAdapter from "axios-mock-adapter";

/* if (process.env.VITE_VUE_APP_MOCKDATA === "true") {
  const Mocks = require("./mocks").default;
  const mock = new MockAdapter(Axios, { onNoMatch: "throwException" });
  Mocks.install(mock);
} */
// Import material symbols font so Vite processes it
// @ts-ignore - Vite handles ?url imports
import materialSymbolsFontUrl from "material-symbols/material-symbols-rounded.woff2?url";
import "./assets/main.css";

// Inject the font-face rule with the processed URL
if (typeof document !== "undefined") {
  const style = document.createElement("style");
  style.textContent = `
    @font-face {
      font-family: "Material Symbols Rounded";
      font-style: normal;
      font-weight: 100 700;
      font-display: block;
      src: url("${materialSymbolsFontUrl}") format("woff2");
    }
  `;
  document.head.appendChild(style);
}
import ISTcomponentsIndex from "./components/ISTcomponentsIndex";
import { IstComponents } from "@ist/brdk_uigruppe";
import CommonUIPlugin from "@ist/commonui-components";

import modal from "./components/modal";
import PrimeVue from "primevue/config";

import "./assets/ist-style.min.css";
import "./assets/ida-style.scss";
import "./assets/animate.css";

import "./assets/quasar.scss";
import VueMatomo from "vue-matomo";
import { VueQueryPlugin, VueQueryPluginOptions } from "@tanstack/vue-query";
import { queryClient } from "./queryClient";
import { initializeQueryInvalidation } from "./utils/queryInvalidation";
import { vFeatureFlag } from "./directives/vFeatureFlag";

// eslint-disable-next-line space-before-function-paren
Date.prototype.toJSON = function (): string {
  return new Date(this.getTime() - this.getTimezoneOffset() * 60000).toISOString().replace("Z", "");
};

// Vue Query global settings live in ./queryClient (shared singleton instance).
const options: VueQueryPluginOptions = { queryClient };

// Initialize query invalidation utilities
initializeQueryInvalidation(queryClient);

const app = createApp(App)
  .use(I18n)
  .use(ISTcomponentsIndex)
  .use(IstComponents)
  .use(CommonUIPlugin)
  .use(mainstore, key)
  .use(modal)
  .use(router)
  .use(quasar)
  .use(PrimeVue)
  .use(VueQueryPlugin, options)
  .mixin(titleMixin);

app.config.globalProperties.$http = Axios;
app.config.globalProperties.$router = router;
app.config.performance = mainstore.state.mainConfig.ENVIRONMENTNAME === "Development";
app.provide("$mainstore", mainstore);
app.provide("emitter", emitter);

// Register feature flag directive
app.directive("feature-flag", vFeatureFlag);

app.use(VueMatomo, {
  host: "https://matomo.ist.com",
  siteId: 26,
  router: router,
  enableLinkTracking: true,
  trackPageView: true
});

app.use(Sentry, router);
app.mount("#app");

// Dev-only UI annotation overlay: mark elements in the browser, attach change
// notes, and copy them as markdown for pasting into an AI chat. Dynamically
// imported behind the DEV guard so it is excluded from production builds.
if (import.meta.env.DEV) {
  import("./dev/installDevAnnotator").then((m) => m.installDevAnnotator());
}

mainstore.dispatch("GetConfig").then(() => {
  const props = router.resolve({
    name: "home"
  });
  mainstore.dispatch("security/setLogoutUrl", new URL(props.href, window.location.href || "").href);
});
